import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { EnvService, IStorageSession } from "namirasoft-core";
import { NamirasoftSchedulerServer } from "namirasoft-scheduler/dist/NamirasoftSchedulerServer";
import { NSNotFoundPage } from "namirasoft-site-react";
import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { SchedulerLayout } from "./SchedulerLayout";
import { SchedulerRoutes } from "./SchedulerRoutes";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import SchedulerEditPage from "./pages/SchedulerEditPage";
import SchedulerListPage from "./pages/SchedulerListPage";
import SchedulerViewPage from "./pages/SchedulerViewPage";

function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        product_id={ProductUUID.NAMIRASOFT_SCHEDULER}

        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let REACT_APP_BASE_URL_SCHEDULER = new EnvService("REACT_APP_BASE_URL_SCHEDULER", true).getString();

            let scheduler = new NamirasoftSchedulerServer(REACT_APP_BASE_URL_SCHEDULER, result.account.token_manager, result.notifier.onError);

            let servers = { scheduler };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows) => (
                        <Routes>
                            <Route path={SchedulerRoutes.Home} element={<HomePage {...result} servers={servers} />} />

                            <Route path={SchedulerRoutes.SchedulerList} element={<SchedulerListPage {...result} servers={servers} />} />
                            <Route path={SchedulerRoutes.SchedulerNew} element={<SchedulerEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={SchedulerRoutes.SchedulerView(":id")} element={<SchedulerViewPage {...result} servers={servers} />} />
                            <Route path={SchedulerRoutes.SchedulerEdit(":id")} element={<SchedulerEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={SchedulerRoutes.SchedulerCopy(":id")} element={<SchedulerEditPage {...result} servers={servers} isEdit={false} />} />

                            {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                            <Route path="*" element={<NSNotFoundPage />} />
                        </Routes >
                    )}
                />
            );
        }}
        renderOnLogout={() => (
            <Routes>
                <Route path={SchedulerRoutes.Home} element={<LoginPage />} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        )}
        navigate={navigate}
        getNSALayout={(props) => (
            <SchedulerLayout {...props}>
                {props.children}
            </SchedulerLayout>
        )}
        requirement={{
            verification: {
                email: true,
                phone: false
            }
        }}
    />
}

export default Router;